export default {
    productionSites: [],
    productionSitesLoading: false,
    productionSiteGroups: [],
    filters: setInitialFilters(),
    setInitialFilters: setInitialFilters
}

function setInitialFilters() {
    return {
        search: null,
        type_id: null
    }
}